// extracted by mini-css-extract-plugin
module.exports = {"faqMoreHelp":"faq-more-help_faqMoreHelp__4sZch"};